(() => {
  if (window.bfBundlesInitialized) return;
  window.bfBundlesInitialized = true;
  const instances = new Map();
  function init(root) {
    const track = root.querySelector('.bf-bundles__list');
    const variantNodes = Array.from(root.querySelectorAll('[data-bundle-variant]'));
    const imageMappings = Array.from(root.querySelectorAll('[data-variant-id]'));
    const signature = JSON.stringify(imageMappings.map(node => [node.dataset.variantId, node.dataset.variantMatch, node.dataset.image, node.dataset.alt]));
    const existing = instances.get(root);
    if (existing && existing.track === track && existing.signature === signature &&
      existing.variantNodes.length === variantNodes.length && existing.variantNodes.every((node, i) => node === variantNodes[i])) return;
    if (existing) { existing(); instances.delete(root); }
    if (!track) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const updateVariant = select => {
      const card = select.closest('article');
      const choice = select.selectedOptions[0];
      if (!card || !choice) return;
      card.querySelector('[data-bundle-price]').textContent = choice.dataset.price;
      const compare = card.querySelector('[data-bundle-compare]');
      compare.textContent = choice.dataset.compare;
      compare.hidden = !choice.dataset.compare;
      const button = card.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = choice.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : (button.dataset.label || 'Add to Cart');
        button.removeAttribute('aria-label');
      }
      card.querySelectorAll('.bf-bundles__media a, h3 a, a.bf-bundles__button').forEach(link => { link.href = choice.dataset.url; });
      const normalizeMatch = value => String(value || '').trim().toLowerCase();
      const custom = Array.from(card.querySelectorAll('[data-variant-id]')).find(node => {
        if (!node.dataset.image) return false;
        const id = String(node.dataset.variantId || '').trim();
        if (id) return id === choice.value;
        const match = normalizeMatch(node.dataset.variantMatch);
        return !!match && (match === normalizeMatch(choice.dataset.sku) || match === normalizeMatch(choice.dataset.title));
      });
      const image = card.querySelector('.bf-bundles__media img');
      const placeholder = card.querySelector('[data-bundle-placeholder]');
      const showPlaceholder = !custom && choice.dataset.placeholder === 'true';
      if (placeholder) {
        placeholder.hidden = !showPlaceholder;
        placeholder.querySelectorAll('[data-placeholder-index]').forEach(node => {
          node.hidden = node.dataset.placeholderIndex !== (choice.dataset.placeholderIndex || '1');
        });
        const placeholderLabel = placeholder.querySelector('[data-placeholder-label]');
        if (placeholderLabel) placeholderLabel.textContent = choice.dataset.title || '';
      }
      if (image) image.hidden = showPlaceholder;
      const src = custom?.dataset.image || choice.dataset.image;
      if (image && src && !showPlaceholder) {
        image.removeAttribute('srcset');
        if (image.getAttribute('src') !== src) image.src = src;
        image.alt = custom?.dataset.alt || choice.dataset.alt;
      }
    };
    track.addEventListener('change', event => {
      if (event.target.matches('[data-bundle-variant]')) updateVariant(event.target);
    }, options);
    const menus = [];
    root.querySelectorAll('[data-bundle-variant]').forEach(select => {
      updateVariant(select);
      const wrapper = select.parentElement;
      wrapper.querySelector('[data-bundle-picker]')?.remove();
      const picker = document.createElement('div');
      picker.className = 'bf-bundles__picker';
      picker.dataset.bundlePicker = '';
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'bf-bundles__variant-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const list = document.createElement('div');
      list.id = `${select.id}-options`;
      list.className = 'bf-bundles__variant-menu';
      list.setAttribute('role', 'listbox');
      list.setAttribute('popover', 'manual');
      const label = select.labels[0]?.textContent || 'Choose a variant';
      list.setAttribute('aria-label', label);
      trigger.setAttribute('aria-controls', list.id);
      list.hidden = true;
      const items = Array.from(select.options, option => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'bf-bundles__variant-option';
        item.setAttribute('role', 'option');
        item.tabIndex = -1;
        item.textContent = option.textContent;
        item.dataset.available = option.dataset.available;
        if (option.dataset.available === 'false') item.setAttribute('aria-label', `${option.textContent}, Sold out`);
        item.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
          close(true);
        }, options);
        list.append(item);
        return item;
      });
      const sync = () => {
        trigger.textContent = select.selectedOptions[0].textContent;
        trigger.dataset.available = select.selectedOptions[0].dataset.available;
        trigger.setAttribute('aria-label', `${label}: ${trigger.textContent}`);
        items.forEach((item, index) => item.setAttribute('aria-selected', String(index === select.selectedIndex)));
      };
      const close = (focus = false) => {
        if (list.matches(':popover-open')) list.hidePopover();
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        if (focus) trigger.focus({ preventScroll: true });
      };
      const open = (index = select.selectedIndex) => {
        menus.forEach(menu => menu.close());
        const rect = trigger.getBoundingClientRect();
        const roomBelow = window.innerHeight - rect.bottom - 12;
        const above = roomBelow < 120 && rect.top > roomBelow;
        wrapper.dataset.menuAbove = String(above);
        list.dataset.above = String(above);
        list.style.width = `${rect.width}px`;
        list.style.left = `${Math.max(8, Math.min(rect.left, window.innerWidth - rect.width - 8))}px`;
        list.style.maxHeight = `${Math.max(60, Math.min(220, above ? rect.top - 12 : roomBelow))}px`;
        list.style.top = above ? 'auto' : `${rect.bottom}px`;
        list.style.bottom = above ? `${window.innerHeight - rect.top}px` : 'auto';
        list.hidden = false;
        if (list.showPopover) list.showPopover();
        trigger.setAttribute('aria-expanded', 'true');
        items[Math.max(0, index)]?.focus({ preventScroll: true });
      };
      trigger.addEventListener('click', () => list.hidden ? open() : close(), options);
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          open(event.key === 'ArrowUp' ? items.length - 1 : select.selectedIndex);
        }
      }, options);
      let typed = '', typedAt = 0;
      list.addEventListener('keydown', event => {
        const index = items.indexOf(document.activeElement);
        let target;
        if (event.key === 'ArrowDown') target = (index + 1) % items.length;
        if (event.key === 'ArrowUp') target = (index - 1 + items.length) % items.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = items.length - 1;
        if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
        if (event.key === 'Tab') { close(true); return; }
        if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey && !event.altKey) {
          typed = Date.now() - typedAt > 700 ? event.key : typed + event.key;
          typedAt = Date.now();
          const match = items.findIndex(item => item.textContent.toLowerCase().startsWith(typed.toLowerCase()));
          if (match >= 0) target = match;
        }
        if (target !== undefined) { event.preventDefault(); items[target].focus({ preventScroll: true });
          items[target].scrollIntoView({ block: 'nearest' }); }
      }, options);
      select.addEventListener('change', sync, options);
      picker.append(trigger, list);
      select.after(picker);
      select.hidden = true;
      sync();
      menus.push({ picker, close });
    });
    document.addEventListener('click', event => {
      menus.forEach(menu => { if (!menu.picker.contains(event.target)) menu.close(); });
    }, options);
    document.addEventListener('focusin', event => {
      menus.forEach(menu => { if (!menu.picker.contains(event.target)) menu.close(); });
    }, options);
    track.addEventListener('scroll', () => menus.forEach(menu => menu.close()), { ...options, passive: true });
    window.addEventListener?.('resize', () => menus.forEach(menu => menu.close()), options);
    document.addEventListener('scroll', event => { if (!event.target.closest?.('.bf-bundles__variant-menu')) menus.forEach(menu => menu.close()); }, { ...options, capture: true, passive: true });
    const cleanup = () => { menus.forEach(menu => menu.close()); controller.abort(); };
    Object.assign(cleanup, { track, variantNodes, signature });
    instances.set(root, cleanup);
  }
  const scan = scope => {
    if (scope.matches?.('[data-bf-bundles]')) init(scope);
    scope.querySelectorAll('[data-bf-bundles]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
  // Theme preview hot reload can replace nodes without a section:load event.
  if (typeof MutationObserver !== 'undefined' && document.body) {
    new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'attributes') {
          const root = record.target.closest?.('[data-bf-bundles]');
          if (root) roots.add(root);
          continue;
        }
        if (![...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1)) continue;
        const parent = record.target.closest?.('[data-bf-bundles]');
        if (parent) roots.add(parent);
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-bf-bundles]')) roots.add(node);
          node.querySelectorAll('[data-bf-bundles]').forEach(root => roots.add(root));
        }
      }
      for (const [root, cleanup] of instances) {
        if (!root.isConnected) { cleanup(); instances.delete(root); }
      }
      roots.forEach(root => { if (root.isConnected) init(root); });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-variant-match', 'data-image', 'data-alt'] });
  }
})();
